import { render } from "./LanguagesDropdown.vue?vue&type=template&id=211672d1"
import script from "./LanguagesDropdown.vue?vue&type=script&lang=js"
export * from "./LanguagesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__